import {
  FACTURADO,
  NUMROWSTATEINVOICE,
  PENDIENTEFACTURAR,
  PENDIENTEPRESUPUESTO,
  PENDIENTERESERVA,
  PENDIENTEVOUCHER,
  ROLADMIN,
  ROLREVENDEDOR,
  ROLVENDEDOR,
} from './constants';
import dateFormat from 'dateformat';

const isEmpty = obj => {
  return Object.keys(obj || {}).length === 0;
};

export const buildFilterInvoice = (filterList, page, dateRange, rol, loggedUser, dateField) => {
  const isActivityDate = dateField === 'FechaActividad';
  const safeDateField = dateField === 'FechaPagoReserva' ? 'FechaPagoReserva' : 'FechaVenta';
  const dateFieldFilter = isActivityDate
    ? {}
    : {
        [safeDateField]: {
          between: [`${dateFormat(dateRange[0], 'isoUtcDateTime')}`, `${dateFormat(dateRange[1], 'isoUtcDateTime')}`],
        },
      };
  let complexWhereFilter = {};
  const whereFilter = {
    ...dateFieldFilter,
  };

  if (filterList && filterList.length > 0) {
    if (
      filterList[5] &&
      filterList[5].length > 0 &&
      filterList[5][0] &&
      (rol === ROLREVENDEDOR || rol === ROLVENDEDOR)
    ) {
      whereFilter['FkUsuarios'] = loggedUser;
    }
    if (filterList[0] && filterList[0].length > 0 && filterList[0][0]) {
      whereFilter['PkVentas'] = filterList[0][0];
    }
    if (filterList[1] && filterList[1].length > 0 && filterList[1][0]) {
      whereFilter['FkClientes'] = filterList[1][0];
    }
    if (filterList[4] && filterList[4].length > 0 && filterList[4][0] && filterList[4][0] === PENDIENTEPRESUPUESTO) {
      whereFilter['PresupuestoEnviado'] = false;
      whereFilter['VoucherEnviado'] = false;
      whereFilter['ReservaPagada'] = false;
    }
    if (filterList[4] && filterList[4].length > 0 && filterList[4][0] && filterList[4][0] === PENDIENTEVOUCHER) {
      whereFilter['VoucherEnviado'] = false;
      whereFilter['ReservaPagada'] = true;
      whereFilter['PresupuestoEnviado'] = true;
    }

    if (filterList[4] && filterList[4].length > 0 && filterList[4][0] && filterList[4][0] === PENDIENTERESERVA) {
      whereFilter['VoucherEnviado'] = false;
      whereFilter['ReservaPagada'] = false;
      whereFilter['PresupuestoEnviado'] = true;
    }

    if (filterList[4] && filterList[4].length > 0 && filterList[4][0] && filterList[4][0] === PENDIENTEFACTURAR) {
      // rectificadaACero = false && importeFactura = 0
      complexWhereFilter = {
        and: [
          ...(!isActivityDate ? [dateFieldFilter] : []),
          { rectificadaACero: false },
          { ImporteFactura: { eq: 0 } },
        ],
      };
    }

    if (filterList[4] && filterList[4].length > 0 && filterList[4][0] && filterList[4][0] === FACTURADO) {
      // rectificadaACero = true || importeFactura > 0
      complexWhereFilter = {
        and: [
          ...(!isActivityDate ? [dateFieldFilter] : []),
          {
            or: [{ rectificadaACero: true }, { ImporteFactura: { gt: 0 } }],
          },
        ],
      };
    }

    if (filterList[5] && filterList[5].length > 0 && filterList[5][0] && rol === ROLADMIN) {
      whereFilter['FkUsuarios'] = filterList[5][0];
    }

    if (filterList[11] && filterList[11].length > 0 && filterList[11][0]) {
      whereFilter['FkComisionistas'] = filterList[11][0];
    }
  }
  const filterquery = {
    limit: NUMROWSTATEINVOICE,
    skip: page * NUMROWSTATEINVOICE,
    order: `${safeDateField} DESC`,
    include: [
      {
        relation: 'Usuario',
      },
      {
        relation: 'Cliente',
      },
      {
        relation: 'Comisionista',
      },
    ],
  };
  const filterquerySum = {};
  const filterQueryCSV = {};
  if (!isEmpty(complexWhereFilter)) {
    filterquery['where'] = complexWhereFilter;
  } else if (!isEmpty(whereFilter)) {
    filterquery['where'] = whereFilter;
    filterquerySum['where'] = whereFilter;
    filterQueryCSV['where'] = whereFilter;
  }
  const encodedFilter = JSON.stringify(filterquery);
  const activityQueryParams = isActivityDate
    ? `fechaActividadDesde=${encodeURIComponent(
        dateFormat(dateRange[0], 'isoUtcDateTime'),
      )}&fechaActividadHasta=${encodeURIComponent(dateFormat(dateRange[1], 'isoUtcDateTime'))}`
    : '';
  const appendActivityParams = baseQuery =>
    activityQueryParams ? `${baseQuery}${baseQuery.includes('?') ? '&' : '?'}${activityQueryParams}` : baseQuery;
  let query = appendActivityParams(`/ventas?filter=${encodedFilter}`);
  let queryCount = appendActivityParams(`/ventas/count?filter=${encodedFilter}`);
  const sumCount = appendActivityParams(`/ventas/sum?filter=${JSON.stringify(filterquerySum)}`);
  const csvQuery = appendActivityParams(`/ventas/csv?filter=${JSON.stringify(filterQueryCSV)}`);

  return [query, queryCount, sumCount, csvQuery];
};

export const buildFilterCVS = (dateRange, dateField) => {
  const isActivityDate = dateField === 'FechaActividad';
  const safeDateField = dateField === 'FechaPagoReserva' ? 'FechaPagoReserva' : 'FechaVenta';
  const whereFilter = isActivityDate
    ? {}
    : {
        [safeDateField]: {
          between: [`${dateFormat(dateRange[0], 'isoUtcDateTime')}`, `${dateFormat(dateRange[1], 'isoUtcDateTime')}`],
        },
      };
  const filterQueryCSV = {
    include: [
      {
        relation: 'Usuario',
      },
      {
        relation: 'Cliente',
      },
      {
        relation: 'Comisionista',
      },
    ],
  };
  if (!isEmpty(whereFilter)) {
    filterQueryCSV['where'] = whereFilter;
  }
  const encodedFilter = JSON.stringify(filterQueryCSV);
  const activityQueryParams = isActivityDate
    ? `fechaActividadDesde=${encodeURIComponent(
        dateFormat(dateRange[0], 'isoUtcDateTime'),
      )}&fechaActividadHasta=${encodeURIComponent(dateFormat(dateRange[1], 'isoUtcDateTime'))}`
    : '';
  const csvQuery = activityQueryParams
    ? `/ventas/csv?filter=${encodedFilter}&${activityQueryParams}`
    : `/ventas/csv?filter=${encodedFilter}`;

  return [csvQuery];
};
